
import ControllerBase from '../../../../global/js/ControllerBase';
export default class ControllerTabbedContent extends ControllerBase {

	private wrapper;
	private wrapperInner;
	private wrapperWidth;
	private tabRow;
	private tabRowWidth;
	private tabLiElements;
	private jellyBar;
	private tabNavButtons;
	private scrollAmount = 0;
	private navButtonsWidth = 232;
	private prevBtn;
	private nextBtn;
	private tabContentCollection;
	private tabIndex;
	private tabCircle;

	constructor(element: HTMLElement) {
		super(element);

		this.init();

		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => this.init(), 250);
		});
	}

	private init() {

		this.wrapper = this.$element.querySelector('.tab-wrapper') as HTMLElement;
		this.wrapperInner = this.$element.querySelector('.tab-wrapper .tab-wrapper-inner') as HTMLElement;
		this.tabRow = this.$element.querySelector('.js-oneRow') as HTMLElement;
		this.tabLiElements = this.$element.querySelectorAll('.tab') as NodeListOf<Element>;
		this.jellyBar = this.$element.querySelector('.jelly-bar') as HTMLElement;
		this.tabNavButtons = this.$element.querySelector('.o-tabbed-content__tab-nav') as HTMLElement;
		this.prevBtn = this.$element.querySelector('.o-tabbed-content--arrow.arrow-left') as HTMLElement;
		this.nextBtn = this.$element.querySelector('.o-tabbed-content--arrow.arrow-right') as HTMLElement;
		this.tabContentCollection = this.$element.querySelectorAll('.uk-switcher > li') as NodeListOf<Element>;
		this.tabCircle = this.$element.classList.contains('tab-circle');

		this.tabLiElements.forEach(element => {
			setTimeout(() => {
				const elWidth = Math.ceil(element.clientWidth);
				const offset = element.offsetLeft;
				element.setAttribute('data-width', elWidth);
				element.setAttribute('data-offset', offset);
			}, 300);
		});

		this.tabLiElements?.forEach((element: HTMLElement) => {
			if (element.classList.contains('uk-active')) this.tabIndex = element.getAttribute('data-tab-index');
		});

		this.tabLiElements.forEach(item => {
			item.addEventListener("click", () => {
				if (!item.classList.contains('uk-active')) {
					const jellyWidth = item.clientWidth;
					const jellyOffset = item.offsetLeft;
					this.jellyBar.style.width = `${0}px`;
					this.jellyBar.style.left = `${jellyOffset}px`;
					this.jellyBar.style.transitionDelay = '0.2s';
					setTimeout(() => this.jellyBar.style.width = `${jellyWidth}px`, 300);
				}
				this.tabIndex = item.getAttribute('data-tab-index')
				this.tabContentHandler();
			});
		});

		this.navButtonsHandler();
		this.selectMobileHandler();
		this.scrollHandler();
		this.tabContentHandler();
		setTimeout(() => this.jellyHandler(), 450);
	}

	private jellyHandler() {
		const itemsArray = [].slice.call(this.$element.querySelectorAll('.tab-wrapper li.tab'));
		const activeItem = itemsArray?.filter(item => item?.classList?.contains('uk-active'))?.[0];
		if (activeItem) {
			const jellyWidth = activeItem.clientWidth;
			const jellyOffset = activeItem.offsetLeft;
			this.jellyBar.style.width = `${jellyWidth}px`;
			this.jellyBar.style.left = `${jellyOffset}px`;
			this.tabContentCollection[this.tabIndex - 1].classList.add('uk-active');
		}
	}

	private navButtonsHandler() {
		this.wrapperWidth = this.wrapper?.clientWidth;
		this.scrollAmount = this.wrapperWidth - this.navButtonsWidth;
		const rowWidth: number[] = [];
		this.tabLiElements?.forEach((el: HTMLElement) => rowWidth.push(el.clientWidth));
		this.tabRowWidth = rowWidth.reduce((acc, cur) => acc + cur, 0);

		if (this.wrapperInner && this.tabRow && this.wrapper) {
			this.wrapperInner.style.width = `${this.tabRowWidth + 80}px`;
			this.tabRow.style.width = `${this.tabRowWidth}px`;
			if (this.wrapperWidth >= this.tabRowWidth) {
				this.tabNavButtons.classList.add('uk-hidden');
				this.wrapper.classList.remove('with-navigation');
			}
			else {
				this.tabNavButtons.classList.remove('uk-hidden');
				this.wrapper.classList.add('with-navigation');
			}
		}

	}

	private selectMobileHandler(): void {
		const select = this.$element.querySelector('.js-selectTab');
		select?.addEventListener('change', e => {
			const tab = this.$element.querySelector('.tabs-row .js-tab-navigation[title="' + (<HTMLSelectElement>e.target).value + '"]') as HTMLAnchorElement;
			tab.click();
		})
	}

	private scrollHandler() {

		this.prevBtn?.addEventListener('click', () => {
			this.wrapper.scrollTo(this.wrapper.scrollLeft - this.scrollAmount, 0)
			if (this.wrapper.scrollLeft - this.scrollAmount <= 0) this.prevBtn.classList.add('disabled');
			if (this.wrapper.scrollLeft + this.scrollAmount < this.tabRowWidth) this.nextBtn.classList.remove('disabled');
		});

		this.nextBtn?.addEventListener('click', () => {
			this.wrapper.scrollTo(this.wrapper.scrollLeft + this.scrollAmount, 0);
			this.prevBtn.classList.remove('disabled');
			if (this.wrapper.scrollLeft + this.scrollAmount + this.wrapperWidth >= this.tabRowWidth) this.nextBtn.classList.add('disabled');
		});

	}

	private tabContentHandler() {
		this.tabContentCollection.forEach((element: Element) => element?.classList.remove('uk-active'));
		this.tabContentCollection[(this.tabIndex ? this.tabIndex : 1) - 1]?.classList.add('uk-active');
	}

}
